<!-- <template>
    <div class="steps-bar">
        <div v-for="(step, index) in steps" :key="index" :class="{ 'step-highlighted': index === currentStep }">
        {{ step }}
        </div>
    </div>
</template>
  
<script>
export default {
props: {
    currentStep: {
    type: Number,
    required: true
    }
},
data() {
    return {
    steps: ['登录', '阅读协议', '注销']
    };
}
};
</script>
  
<style>
.steps-bar {
display: flex;
justify-content: space-around;
align-items: center;
background-color: #f0f0f0;
padding: 10px;
}

.step-highlighted {
font-weight: bold;
color: #007bff; /* 高亮颜色 */
}
</style>
   -->
<template>
<!-- <div class="steps-bar"> -->
    <!-- <div v-for="(step, index) in steps" :key="index" class="step-container">
    <div :class="{ 'step-highlighted': index === currentStep }" class="step">
        {{ step }}
    </div>
    <div v-if="index < steps.length - 1" class="arrow">&#8594;</div>
    </div> -->
<div class="step-box">
    <el-steps :active="currentStep" align-center>
        <!-- eg <el-step title="登录" description="登录" />  -->
        <el-step :title="$t('step_1')"/>
        <el-step :title="$t('step_2')"/>
        <el-step :title="$t('step_3')"/>
    </el-steps>
</div>

<!-- </div> -->
</template>

<script>
export default {
props: {
    currentStep: {
    type: Number,
    required: true
    }
},
data() {
    return {
    steps: ['登录', '阅读协议', '注销']
    };
}
};
</script>

<style>
.step-box {
    width: 1229px;
    margin: 0 auto; /* 这个属性将使元素水平居中 */
}

.steps-bar {
display: flex;
justify-content: center;
align-items: center;
background-color: #f0f0f000;
padding: 10px;
width: 1229px;
margin: 0 auto; /* 这个属性将使元素水平居中 */
}

.step-container {
display: flex;
align-items: center;
}

.step {
margin: 0 10px;
padding: 10px;
border: 2px solid #007bff;
border-radius: 5px;
background-color: #fff;
}

.step-highlighted {
font-weight: bold;
color: #007bff;
}

.arrow {
margin: 0 10px;
font-size: 18px;
color: #007bff;
}
</style>
  